import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=23028aa4"
import script from "./Preferences.vue?vue&type=script&lang=ts"
export * from "./Preferences.vue?vue&type=script&lang=ts"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23028aa4')) {
      api.createRecord('23028aa4', component.options)
    } else {
      api.reload('23028aa4', component.options)
    }
    module.hot.accept("./Preferences.vue?vue&type=template&id=23028aa4", function () {
      api.rerender('23028aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Preferences.vue"
export default component.exports